import {
  hamburgerButton,
  overlay,
  menuParentItems,
  sidebar,
  cards,
  themeButtons,
  calendarButtons,
} from './lib/elements.js';
import {
  toggleMenu,
  handleMenuClick,
  handleCardClick,
  makeSidebarSticky,
  applyCalendarSettings,
} from './lib/handlers.js';
import {
  handleFirstTab,
  disableAnimationOnResize,
  scrollbarFix,
} from './lib/lib.js';
import { applyThemeSetting, toggleThemeSetting } from './lib/dark-theme.js';

// Hamburger toggle
hamburgerButton.addEventListener('click', toggleMenu);
overlay.addEventListener('click', toggleMenu);
document.addEventListener('keyup', toggleMenu);

// Remove :focus outline unless user is using the keyboard to navigate
window.addEventListener('keydown', handleFirstTab);

// Disable animations on window resize to improve performace
window.addEventListener('resize', disableAnimationOnResize);

// Apply user theme settings on load
applyThemeSetting();

// Change theme on button click
themeButtons.forEach((item) =>
  item.addEventListener('click', (e) => {
    applyThemeSetting(toggleThemeSetting(e));
  })
);

// Handle calendar visibility options
calendarButtons.forEach((item) =>
  item.addEventListener('click', applyCalendarSettings)
);

// Handle menu clicks
menuParentItems.forEach((item) =>
  item.addEventListener('click', handleMenuClick)
);

// Apply scrollbar fix to full-bleed class on load and resize
scrollbarFix();
window.addEventListener('resize', scrollbarFix);

// Apply sticky sidebar class
if (sidebar) {
  // makeSidebarSticky();
  document.addEventListener('DOMContentLoaded', makeSidebarSticky);
  window.addEventListener('resize', makeSidebarSticky);
}

// Handle card clicks
cards.forEach((item) => item.addEventListener('click', handleCardClick));
